import React from 'react';
import { toDecimalComma } from '../../utils/decimalUtils';

/**
 * Поле для дробного числа: показывает его через запятую, а набранную точку
 * сразу заменяет запятой — курсор при этом остаётся на месте.
 *
 * Обработчик onChange получает событие, в котором e.target.value уже с
 * запятой, поэтому значение для хранения он берёт через toDecimalPoint: в
 * карточке числа по-прежнему лежат с точкой. value можно отдавать как есть —
 * с точкой, с запятой или числом.
 *
 * Остальные свойства уходят в <input> без изменений (className, onBlur,
 * readOnly, ref и т.д.); type всегда text: type="number" запятую не покажет.
 */
const DecimalInput = ({ value, onChange, placeholder, type, inputMode = 'decimal', ...props }) => {
  const handleChange = (e) => {
    const input = e.target;
    const typed = input.value;
    const shown = toDecimalComma(typed);
    if (shown !== typed) {
      // Замена символ в символ — длина та же, курсор возвращаем, где был
      const { selectionStart, selectionEnd } = input;
      input.value = shown;
      if (selectionStart !== null) input.setSelectionRange(selectionStart, selectionEnd);
    }
    if (onChange) onChange(e);
  };

  return (
    <input
      {...props}
      type="text"
      inputMode={inputMode}
      value={toDecimalComma(value)}
      onChange={handleChange}
      placeholder={placeholder === undefined ? undefined : toDecimalComma(placeholder)}
    />
  );
};

export default DecimalInput;
